import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSagas from "./sagas";
import { globalReducers } from "./reducers";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from "redux-persist";

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

const configureStore = () => {

    const persistConfig = {
        key: 'root',
        storage: storage,
        whitelist: ['auth'],
    };

    const pReducer = persistReducer(persistConfig, globalReducers);

    const sagaMiddleware = createSagaMiddleware();
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware));
    const store = createStore(pReducer, enhancer);
    const persistor = persistStore(store);

    sagaMiddleware.run(rootSagas);
    return { store, persistor };
};

const { store, persistor } = configureStore();

export { store, persistor };
